export default __webpack_public_path__ + "static/media/LOGO PALMILHA FISIOFLEX_ok.92cfc735.svg";